import { ColumnDefinition, RowDefinition } from '@indigo-ag/component-module';
import ValidatedCell from './ValidatedCell';
import TextCell from './TextCell';
import React from 'react';
import { CreditConditional } from '@indigo-ag/schema';
import { getConditionalText } from 'shared';
import i18next from 'i18next';

export interface ConditionalsValidationRow {
  id: string | number;
  conditional: string | CreditConditional;
  observation: string;
  validated: boolean;
}

export type ColumnId = 'validated' | 'name' | 'observation';

export const columnDefinition: ColumnDefinition<ConditionalsValidationRow, ColumnId>[] = [
  {
    id: 'validated',
    header: i18next.t('conditionalValidations-header-validated'),
    cell: ({ row }) => <ValidatedCell validated={row.validated} />,
    constraints: {
      min: { rem: 2 },
      max: { fr: 0.35 }
    }
  },
  {
    id: 'name',
    header: i18next.t('conditionalValidations-header-name'),
    cell: ({ row }) => <TextCell text={getConditionalText(row.conditional)} />,
    constraints: {
      min: { rem: 5 },
      max: { fr: 1 }
    }
  },
  {
    id: 'observation',
    header: i18next.t('conditionalValidations-header-observation'),
    cell: ({ row }) => <TextCell text={row.observation} />,
    constraints: {
      min: { rem: 8 },
      max: { fr: 1.5 }
    }
  }
];

export const rowDefinition: RowDefinition<ConditionalsValidationRow, ColumnId> = {
  rowId: ({ row }) => row.conditional
};

export const data: ConditionalsValidationRow[] = [
  {
    id: '1',
    conditional: CreditConditional.RESTRICTIONS_SETTLEMENT_BEFORE_DISBURSEMENT,
    observation: 'Observação 1',
    validated: true
  },
  {
    id: '2',
    conditional: CreditConditional.COLLECTION_VISIT,
    observation: 'Observação 2',
    validated: true
  },
  {
    id: '3',
    conditional: 'Alguma outra condição',
    observation: 'Observação 3',
    validated: true
  }
];
